import React from 'react';
import {createUseStyles} from 'react-jss';

import {TEXT} from '../../../common-styles/typography-style';
import {SELECT_DATE} from '../../../utils/action-types';
import {COLORS} from '../../../utils/style-variables';
import DynamicComponent from '../../common/dynamicComponent';
import {CalendarIcon} from '../../icons/calendar-icon';

const useStyles = createUseStyles({

  date: {
    display: 'inline-block',
    position: 'relative',
    padding: '9px 14px 9px 34px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: COLORS.lightGrey60Color,
    borderRadius: 2,
    ...TEXT.defaultSize,
    color: COLORS.blackColor,
    outline: 'none',
    transition: 'all .100s ease-in-out',
    '& >svg': {
      position: 'absolute',
      left: 12,
      top: 10,
      '& path': {
        transition: 'all .100s ease-in-out'
      }
    },
    '&:focus, &:hover': {
      borderColor: COLORS.blue100Color,
      '& >svg path': {
        fill: COLORS.blue100Color
      }
    }
  },
  mobileDate: {
    display: 'flex',
    extend: 'date',
    width: '100%',
    '& >input': {
      font: '400 15px/20px Roboto,Arial,Helvetica,sans-serif',
      display: 'block',
      height: 20,
      outline: 'none',
      appearance: 'none',
      background: 'none',
      flexGrow: 1,
      position: 'relative',
      '&::-webkit-calendar-picker-indicator': {
        background: 'none',
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0
      }
    },
    '@media (min-width: 756px)': {
      display: 'none'
    }
  }
});

const MobileDateInput = ({selected, changeDate}) => {
  const classes = useStyles();

  return (
    <label className={classes.mobileDate}>
      <CalendarIcon />
      <input
        type="date"
        value={selected.toISOString().split('T')[0]}
        min={new Date('01/01/2020').toISOString().split('T')[0]}
        max={new Date().toISOString().split('T')[0]}
        onChange={e => changeDate(new Date(e.target.value))}
      />
    </label>
  );
};
const loadDesktopDatePicker = () => import(/* webpackChunkName: "datePicker" */'./desktop-date-picker');

export const CustomDatePicker = ({changeDate, selected}) => {
  const dateHandler = val => {
    changeDate({
      type: SELECT_DATE,
      payload: val
    });
  };

  return (
    <>
      <MobileDateInput
        selected={selected}
        changeDate={dateHandler}
      />
      <DynamicComponent
        props={{selected, dateHandler}}
        onLoad={loadDesktopDatePicker}
        isLoading={window.innerWidth > 755}
      />
    </>
  );
};

